module.exports = __webpack_public_path__ + "static/img/u962.2ed5b7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/u962.svg
// module id = RpgF
// module chunks = 209